import React from "react";
import { Box } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { FONT } from "./roomTheme";

/*
 * Slide-to-bid track (mobile). Markup and look only.
 *
 * The slide mechanics are unchanged and stay in rightLayout.jsx: it passes the two refs
 * and its mouse / touch handlers, and decides when the knob is draggable (onMouseDown /
 * onTouchStart are undefined when bidding is not allowed). The geometry the mechanics rely
 * on is kept: relative track, absolute knob 50% wide starting at left 0 (or 50% when you
 * are the highest bidder), with the same left transition.
 */
export default function SlideToBidControl({
  containerRef,
  sliderRef,
  containerHandlers,
  onKnobMouseDown,
  onKnobTouchStart,
  winning,
  isAdmin,
  highestBidText,
  nextBidamount
}) {
  const knobLeft = isAdmin ? 0 : winning ? "50%" : 0;

  return (
    <Box
      ref={containerRef}
      {...containerHandlers}
      sx={{
        position: "relative",
        height: 56,
        overflow: "hidden",
        userSelect: "none",
        touchAction: "pan-x",
        bgcolor: winning ? "#1F6B23" : "#1A1A1A",
        color: "#fff",
        fontFamily: FONT,
      }}
    >
      {/* Knob */}
      <Box
        ref={sliderRef}
        onMouseDown={onKnobMouseDown}
        onTouchStart={onKnobTouchStart}
        role="button"
        // `left` stays an inline style, as before: the slide handlers move the knob by
        // writing style.left directly, and React resets it through this same property.
        style={{ left: knobLeft }}
        aria-label={winning ? "You are the highest bidder" : "Slide to place bid"}
        sx={{
          position: "absolute",
          top: 0,
          width: "50%",
          height: "100%",
          zIndex: 2,
          cursor: onKnobMouseDown ? "grab" : "default",
          touchAction: "none",
          transition: "left 0.2s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          px: 1,
          boxSizing: "border-box",
          bgcolor: winning ? "#2E7D32" : "#fff",
          color: winning ? "#fff" : "#111",
          borderRight: winning ? "none" : "1px solid #111",
          textAlign: "center",
        }}
      >
        {winning ? (
          <Box sx={{ lineHeight: 1.15 }}>
            <Box component="span" sx={{ display: "block", fontSize: "0.9375rem", fontWeight: 700, whiteSpace: "nowrap" }}>
              {nextBidamount}
            </Box>
            <Box component="span" sx={{ display: "block", fontSize: "0.6rem", letterSpacing: "2px", textTransform: "uppercase" }}>
              Highest bidder
            </Box>
          </Box>
        ) : (
          <>
              <Box sx={{ lineHeight: 1.15 }}>

                 <Box component="span" sx={{ display: "block", fontSize: "0.9375rem", fontWeight: 700, whiteSpace: "nowrap" }}>
              {nextBidamount}
            </Box>
            <Box component="span" sx={{ fontSize: { xs: "0.68rem", sm: "0.8rem" }, fontWeight: 700, letterSpacing: { xs: "1px", sm: "2px" }, textTransform: "uppercase", whiteSpace: "nowrap" }}>
              Slide to bid
            </Box>
            <EastIcon sx={{ fontSize: { xs: 18, sm: 20 }, flexShrink: 0 }} />
           </Box>
          </>
        )}
      </Box>
    </Box>
  );
}
